var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "tile h-100 mb-2" }, [
    _c("div", { staticClass: "container h-100 mw-100 border-2" }, [
      _c("div", { staticClass: "row h-100" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-column px-0 h-100 w-100 bg-header-tile align-items-stretch",
            class: _vm.pushAnimationTileClasses,
            style: _vm.pushAnimationTileStyle,
          },
          [
            _c("tag-timer-banner", {
              attrs: {
                banner: _vm.pushAnimationBanner.tag,
                "timer-end-date-in-milliseconds":
                  _vm.pushAnimationBanner.timerEndDateInMilliseconds,
                "count-down-color": _vm.pushAnimationBanner.countDownColor,
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "flex-grow-1 pt-1" }, [
              _c(
                "div",
                {
                  staticClass:
                    "h-100 d-flex flex-column justify-content-center align-content-center text-center px-1 pb-2",
                  class: _vm.pushAnimationTileTextClasses,
                },
                [
                  _vm.pushAnimation.picture
                    ? _c("div", { staticClass: "mt-0 mb-2 mx-auto" }, [
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: {
                            loading: "lazy",
                            src: _vm.pushAnimation.picture.src,
                            alt: _vm.pushAnimation.picture.alt,
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pushAnimation.title
                    ? _c("span", {
                        staticClass: "mt-0 h4 my-0 mx-auto",
                        domProps: {
                          innerHTML: _vm._s(_vm.pushAnimation.title),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pushAnimation.text
                    ? _c("span", {
                        staticClass: "mt-0 lead mx-auto",
                        domProps: { innerHTML: _vm._s(_vm.pushAnimation.text) },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pushAnimation.additionalText
                    ? _c("span", {
                        staticClass: "mt-0 small mx-auto",
                        domProps: {
                          innerHTML: _vm._s(_vm.pushAnimation.additionalText),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pushAnimationLink
                    ? _c("div", { staticClass: "mt-1 mx-auto" }, [
                        _c("a", {
                          class: _vm.pushAnimationLink.classes,
                          attrs: {
                            href: _vm.pushAnimationLink.href,
                            "data-oevent-category":
                              _vm.pushAnimationLink.tms.category,
                            "data-oevent-action":
                              _vm.pushAnimationLink.tms.action,
                            "data-oevent-label":
                              _vm.pushAnimationLink.tms.label,
                            target: "_self",
                          },
                          domProps: {
                            innerHTML: _vm._s(_vm.pushAnimationLink.label),
                          },
                        }),
                      ])
                    : _vm._e(),
                ]
              ),
            ]),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }